<template>
    <div class="w-full flex flex-col p-8 text-ternary">
        <h1 class="text-2xl font-bold underline">Student Information</h1>
        <div class="flex flex-row flex-wrap mt-6">
            <div class="w-1/4 font-bold">Student Name</div>
            <div class="w-3/4">{{ item.user.students.name_en }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Student ID</div>
            <div class="w-3/4">{{ item.user.students.student_id }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Entity</div>
            <div class="w-3/4">{{ item.user.students.entity }}</div>
        </div>
        <h1 class="text-2xl font-bold underline mt-6">Project Information</h1>
        <div class="flex flex-row flex-wrap mt-6">
            <div class="w-1/4 font-bold">Name</div>
            <div class="w-3/4">{{ item.name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Description</div>
            <div class="w-3/4 show-list" v-html="item.description"></div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Industry</div>
            <div class="w-3/4">{{ item.industry }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Participants</div>
            <div class="w-3/4">{{ item.participants }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">status</div>
            <div class="w-3/4">{{ getStatus }}</div>
        </div>
        <div v-if="item.note" class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">note</div>
            <div class="w-3/4">{{ item.note }}</div>
        </div>
        <h1 class="text-2xl font-bold underline mt-6">Uploaded Images</h1>
        <div v-if="hasAttachments" class="flex flex-col overflow-x-auto">
            <div class="inline-block min-w-full py-2">
                <div class="overflow-x-auto">
                    <table class="min-w-full text-left text-sm font-light">
                        <thead class="border-b font-medium dark:border-neutral-500">
                            <tr>
                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                <th scope="col" class="px-6 py-2 text-gray-400">Image</th>
                                <th scope="col" class="px-6 py-2 text-gray-400 text-center">View</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(attachment, index) in item.attachments" :key="index" class="border-b border-dashed dark:border-neutral-500">
                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{ index + 1 }}</td>
                                <td class="px-6 py-2">
                                    <img class="h-12 w-12 border object-contain" :src="getSrcFile(attachment.path)" alt="Logo">
                                </td>
                                <td class="px-6 py-2 text-center">
                                    <a :href="getSrcFile(attachment.path)" target="_blank" class="flex justify-center">
                                        <icon-eye class="h-6 w-6 cursor-pointer hover:text-twelve"></icon-eye>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>
            <h1 class="text-center text-2xl my-8 text-secondary">No information available</h1>
        </div>
    </div>
</template>

<script>
import IconEye from "../../components/icons/IconEye.vue";
export default {
    name: "project-view",
    components: {
        IconEye,
    },
    props: ["item"],
    computed: {
        getStatus() {
            if (this.item.status === true) {
                return "Approved";
            } else if (this.item.status === false) {
                return "Rejected";
            } else {
                return "Not verified yet";
            }
        },
        hasAttachments() {
            return this.item.attachments.length > 0;
        },
    },
    methods: {
        getSrcFile(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
    },
}
</script>

<style lang="scss">
.show-list {
    ol, ul {
        list-style: revert;
        margin: 0px 20px;
    }
}
</style>